<template>
    <div v-if="turma" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes da Turma nº {{ turma.id || 'Não informado' }}</h4>
        <router-link to="/cadastros/turmas">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <FormSection title="">
          <p><strong>Nível:</strong> {{ turma.nivel_nome || 'Não informado' }}</p>
          <p><strong>Instrutor:</strong> {{ turma.instrutor_nome || 'Não informado' }}</p>
          <p><strong>Ativo:</strong> {{ verificarAtivo(turma?.ativo) }}</p>
        </FormSection>
  
        <FormSection title="Dias e Horários">
          <ul class="list-group">
            <li 
              v-for="(diaHorario, index) in turma.dias_horarios" 
              :key="index" 
              class="list-group-item"
            >
              <strong>Dia:</strong> {{ diaHorario.dia_semana || 'Não informado' }} - 
              <strong>Horário:</strong> {{ diaHorario.horario || 'Não informado' }}
            </li>
          </ul>
        </FormSection>
        <RegularizarAulasPassadas :turma-id="Number(turma.id)" />
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  import RegularizarAulasPassadas from './RegularizarAulasPassadas.vue';
  
  export default {
    components: { FormSection, RegularizarAulasPassadas },
    data() {
      return {
        turma: null,
      };
    },
    methods: {
      async carregarDetalhesTurma() {
        try {
          // Busca os dados da turma
          const response = await axios.get(
            `/cadastros/turmas/${this.$route.params.id}`
          );
          let turmaData = response.data;
  
          // Buscar o nome do nível usando o nivel_id
          try {
            const responseNivel = await axios.get(
              `/cadastros/niveis-turmas/${turmaData.nivel_id}`
            );
            turmaData.nivel_nome = responseNivel.data.nivel || 'Não informado';
          } catch (error) {
            console.error("Erro ao carregar o nível:", error);
            turmaData.nivel_nome = 'Não informado';
          }
  
          // Buscar o nome do instrutor
          try {
            // Primeiro, buscar os dados do funcionário com base no instrutor_id
            const responseFuncionario = await axios.get(
              `/cadastros/funcionarios/${turmaData.instrutor_id}`
            );
            const pessoaFisicaId = responseFuncionario.data.pessoa_fisica_id;
            
            // Em seguida, buscar os dados da pessoa física usando o pessoaFisicaId
            const responsePessoaFisica = await axios.get(
              `/cadastros/pessoas-fisicas/${pessoaFisicaId}`
            );
            turmaData.instrutor_nome = responsePessoaFisica.data.nome || 'Não informado';
          } catch (error) {
            console.error("Erro ao carregar o instrutor:", error);
            turmaData.instrutor_nome = 'Não informado';
          }
  
          this.turma = turmaData;
        } catch (error) {
          console.error("Erro ao carregar os detalhes da turma:", error);
        }
      },
      verificarAtivo(valor) {
        if (valor === undefined || valor === null) {
          console.warn("Campo 'ativo' ausente ou indefinido");
          return "Não informado";
        }
        if (valor === true || valor === "true" || valor === 1 || valor === "1") {
          return "Ativo";
        } else if (valor === false || valor === "false" || valor === 0 || valor === "0") {
          return "Inativo";
        }
        console.warn("Valor inesperado para ativo:", valor);
        return "Valor inválido";
      },
    },
    mounted() {
      this.carregarDetalhesTurma();
    },
  };
  </script>
    
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  
  .form-content {
    margin-top: 1.5rem;
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  
  .list-group-item {
    padding: 10px 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-bottom: 5px;
  }
  </style>
